var path = '/app/pages/login/login.html';
var html = "<div class=step ng-if=!$ctrl.credits> <div class=intro> <div class=page-flip ng-click=$ctrl.redirectToStages()> </div> </div> <div class=btn-credits ng-click=$ctrl.toggleCredits(true)></div> </div> <div class=step ng-if=$ctrl.credits> <div class=credits> <div class=btn-close ng-click=$ctrl.toggleCredits(false)></div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/login/login.html
// module id = 185
// module chunks = 0